import {Action} from '../../actions';

export const ActionTypes = {
  FETCH_OFFER_LIST_PENDING: 'FETCH_OFFER_LIST_PENDING',
  FETCH_OFFER_LIST_FULFILLED: 'FETCH_OFFER_LIST_FULFILLED',
  FETCH_OFFER_LIST_REJECTED: 'FETCH_OFFER_LIST_REJECTED',
  NO_OFFER_FOUND: 'NO_OFFER_FOUND'
};

export interface FetchOfferFulfilledPayload {
  offer: Offer[];
}

export interface Offer {
  id?: string;
  offerId?: string;
  rateCode?: string;
  templates?: any;
}

interface FetchOfferAction {
  type: string;
}

interface FetchOfferAFulfilledAction extends Action<FetchOfferFulfilledPayload> {
  type: string;
  payload: FetchOfferFulfilledPayload;
}

export type OfferActionTypes = FetchOfferAction | FetchOfferAFulfilledAction;
